import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { HeaderPagesService } from '../../header-pages.service';

@Component({
  selector: 'app-add-edit-issue',
  templateUrl: './add-edit-issue.component.html',
  styleUrls: ['./add-edit-issue.component.scss']
})
export class AddEditIssueComponent implements OnInit {
  dataModel = {
    issuetype: null,
    summary: '',
    description: '',
  };

  documentAttachment = {
    documentType: '',
    documentDataBase64: '',
    documentName: '',
  };
  file: any;
  isAddNew = true;
  issueTypeList = [];
  searchCtrlForIssueType = '';
  isInputFileShow = true;

  constructor(
    private dialogRef: MatDialogRef<AddEditIssueComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private headerPagesService: HeaderPagesService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.loadData();
    if (this.data && this.data.issueId) {
      this.getIssueById();
    }
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
  }

  ngOnDestroy() {
    this.sharedService.isPopupOpened.emit({ isPopupOpened: false});
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    this.sharedService.showErrorMessage.emit({error: "", displayError: false});
  }
  
  getIssueById() {
    this.headerPagesService.getIssueById(this.data.issueId).subscribe(res => {
      if (res) {
        this.dataModel = res;
        this.isAddNew = false;
      }
    });
  }

  loadData() {
    this.headerPagesService.getIssueType().subscribe(res => {
      if (res) {
        this.issueTypeList = res;
      }
    });
  }

  fileSelect() {
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    this.documentAttachment.documentType = '';
    this.documentAttachment.documentDataBase64 = '';
    this.documentAttachment.documentName = '';

    const extension = this.file._files[0].name.substring(this.file._files[0].name.lastIndexOf('.')).replace('.', '');
    if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'gif' || extension == 'pdf') {
      this.documentAttachment.documentName = this.file._files[0].name;
      this.documentAttachment.documentType = extension;
      const reader = new FileReader();
      reader.readAsDataURL(this.file._files[0]);
      reader.onload = () => {
        this.documentAttachment.documentDataBase64 = String(reader.result);
      };
    } else {
      this.sharedService.showPopupErrorMessage.emit({error: "Only PDF or image(.jpg, .jpeg, .png, .gif) files can be attached.", displayError: true});
      return;
    }
  }

  saveClick() {
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    let errors = '';
    this.dataModel.summary = this.dataModel.summary.trim();
    this.dataModel.description = this.dataModel.description.trim();

    if (!this.dataModel.issuetype) {
      errors += 'Please select issue type.<br/>';
    }
    if (!this.dataModel.summary) {
      errors += 'Please enter issue summary.<br/>';
    }
    if (!this.dataModel.description) {
      errors += 'Please enter issue description.<br/>';
    }

    if (errors) {
      this.sharedService.showPopupErrorMessage.emit({error: errors, displayError: true});
      return;
    }

    this.headerPagesService.createIssue(this.dataModel).subscribe(res => {
      if (res) {
        this.headerPagesService.createDocument(this.documentAttachment, res.key).subscribe(response => {
          if (response) {
            this.dialogRef.close(true);
          }
        });
      }
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }
}
